export const kebabToCamel = (str = "") => str.replace(/-([a-z])/g, (m, w) => w.toUpperCase());
export const camelToKebab = (string = "") => string.replace(/([A-Z])/g, (match, group) => `-${group.toLowerCase()}`).replace(/^-/, "");
export const toSnakeCase = (str = "") => str
    // Replace all non-alphanumeric characters and spaces with underscores
    .replace(/[\W\s]+/g, "_")
    // Add an underscore before any uppercase letter that is preceded by a lowercase letter
    .replace(/([a-z])([A-Z])/g, "$1_$2")
    // Convert the entire string to lowercase
    .toLowerCase();
export const capitalizeFirstLetter = (str) => {
    if (str.length === 0)
        return str; // Handle empty strings
    return str.charAt(0).toUpperCase() + str.slice(1);
};
